/**
 * CopyToast — Brief notification confirming MGRS string copied to clipboard
 *
 * Renders an absolutely-positioned toast with the copied MGRS text.
 * Auto-dismisses after 2 seconds via useEffect + setTimeout.
 */

import React, { useEffect } from 'react'

/**
 * @param {{ mgrs: string, onDismiss: () => void }} props
 */
export function CopyToast({ mgrs, onDismiss }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onDismiss()
    }, 2000)
    return () => clearTimeout(timer)
  }, [onDismiss])

  return (
    <div className="copy-toast" data-testid="copy-toast">
      Copied: <span className="copy-toast-mgrs">{mgrs}</span>
    </div>
  )
}

export default CopyToast
